const listPaths = ({ goList }: { goList: () => void }) => [
    {
        id: '1',
        label: 'user-schedule',
        navigate: goList
    },
    {
        id: '2',
        label: 'scheduleList',
        navigate: () => { }
    },
]

const detailVisit = ({ seeList, goList }: { seeList: () => void; goList: () => void }) => ([
    {
        id: 'user-schedule',
        label: 'user-schedule',
        navigate: goList
    },
    // {
    //     id: '2',
    //     label: 'scheduleList',
    //     navigate: seeList
    // },
    {
        id: '2',
        label: 'scheduleDetail',
        navigate: () => { }
    },
])

export { detailVisit, listPaths }